<template>
  <li v-if="isShowReports()" v-bind:class="{ treeView: treeView }">
    <!-- <div v-if="item.length > 0" @click="toggle" class="submenu-toggle">
      <span style="font-size:16px">{{ item.name }}</span>
      <span class="ml-auto sm-a">
        <b-icon icon="chevron-right"></b-icon>
      </span>
    </div> -->

    <!-- <router-link v-bind:to="item.url" v-else> -->
        <div class="main-menu">
     
      <a style="font-size:16px;cursor: pointer;" @click="getreportJson(item)">{{ item.name }}</a>
       </div>
    <!-- </router-link> -->

    <!-- <ul v-if="item.name.length" class="submenu">
      <li v-for="(item,index) in item.reports" :key="index">
        
         <a @click="getreportJson(item)">{{item.name}}</a>
        
      </li>
    </ul> -->
  </li>
</template>

<script>
export default {
  props: ["item"],
  data: function() {
    return {
      open: false,
      treeView: false,
    };
  },
  methods: {
    toggle() {
      this.treeView = !this.treeView;
    },
    getreportJson(d){
      console.log(JSON.parse(d.configuration))
       this.$emit("clickEvent",{data:d})
    },
    isShowReports(){
      const configuration = JSON.parse(this.item.configuration);
      return !configuration.isSummeryReport;
    }
  },
};
</script>
<style lang="scss" scoped>
      .main-menu {
         a:hover {
        text-decoration: underline;
        color: gray;
        }
        li {
          a {
            font-size: 13px;
            font-weight: 400;
            // .menu-icon {
            //     // visibility: hidden;
            // }
          }
        }
      }
    .treeView {
      a:hover {
    text-decoration: underline;
        }
        li a {
          font-weight: 500;
        }
        .submenu {
          padding: 0px 0 10px 0;
          -webkit-transition: all 0.3s;
          transition: all 0.3s;
          max-height: 2000px;
        }
        .sm-a svg {
          transition: all 0.3s;
          transform: rotate(90deg);
        }

           li {
       float: left;
  width: 21em;
  margin: 0;
  padding: 0;

        cursor: pointer;
        -webkit-transition: all 200ms ease-in-out;
           -moz-transition: all 200ms ease-in-out;
            -ms-transition: all 200ms ease-in-out;
             -o-transition: all 200ms ease-in-out;
                transition: all 200ms ease-in-out;

        &:hover a {
          text-decoration: underline;
 
        }


        a { 
            // color: #666; 
            text-decoration: none;
        }
    }
        
      }
</style>

